import React from 'react';
import { PRODUCT_MOCKUP, volumes } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-ice px-5 py-20 sm:py-28" data-id="element-250" data-mp="ywag8mv58g14">
      <div className="mx-auto max-w-6xl" data-id="element-251" data-mp="kw81vam1o4qm">
        <div className="grid items-center gap-8 lg:grid-cols-[1fr_auto]" data-id="element-252" data-mp="kvg5vyojc4zt">
          <div className="text-center lg:text-left" data-id="element-253" data-mp="put1p8xdwmej">
            <h2 className="font-display text-[1.8rem] font-extrabold leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-254" data-mp="pxfafbw0h7yc">
              <span aria-hidden="true" data-id="element-255" data-mp="fwwidtuaml5c">📦 </span>Was ist im MATHE BEREIT™ Paket enthalten?
            </h2>
            <div className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-256" data-mp="2604l95108ic">
              {volumes.map(volume => <span key={volume.number} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold text-white ${volume.spine}`} data-id="element-257" data-mp="75mhfhgxzmqm">
                  Band {volume.number}
                </span>)}
            </div>
          </div>
          <img src={PRODUCT_MOCKUP} alt="Die 6 Bände von MATHE BEREIT™ im Schuber" className="mx-auto w-56 drop-shadow-[0_20px_30px_rgba(11,31,75,0.3)] sm:w-64" data-id="element-258" data-mp="3cs2z9i4jekye" />
        </div>

        <ul className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-259" data-mp="3ls9jrnynkl72">
          {volumes.map(volume => {
          const Icon = volume.icon;
          return <li key={volume.number} className="flex overflow-hidden rounded-2xl bg-white shadow-lift" data-id="element-260" data-mp="2u47takf62bfu">
                <div className={`flex w-20 shrink-0 flex-col items-center justify-between py-5 text-white sm:w-24 ${volume.spine}`} data-id="element-261" data-mp="32vq9gvc44r8x">
                  <span className="text-center font-display leading-none" data-id="element-262" data-mp="2y3q951s4rwbt">
                    <span className="block text-[10px] font-bold uppercase tracking-[0.1em] opacity-90" data-id="element-263" data-mp="2ae4d2n721x81">
                      Band
                    </span>
                    <span className="mt-1 block text-3xl font-extrabold" data-id="element-264" data-mp="9dhadaiggpmu">{volume.number}</span>
                  </span>
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-265" data-mp="ebitfvfvsoyb" />
                </div>
                <div className="p-6" data-id="element-266" data-mp="j2hdn63zq76u">
                  <h3 className="font-display text-lg font-extrabold uppercase tracking-tight text-navy" data-id="element-267" data-mp="j3j1yca0oq6i">
                    {volume.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-navy/70" data-id="element-268" data-mp="3mk99ivl8zbab">{volume.subtitle}</p>
                  <ul className="mt-4 flex flex-wrap gap-1.5" aria-label={`Themen in Band ${volume.number}`} data-id="element-269" data-mp="3riavboa25oph">
                    {volume.topics.map(topic => <li key={topic} className="rounded-md bg-ice px-2 py-1 text-xs font-medium text-navy/80" data-id="element-270" data-mp="evxnvzo04tz">
                        {topic}
                      </li>)}
                  </ul>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}